import {
  openTextarea,
  optionalLabel,
  textarea,
  textareaWithEllipsis,
  textareaWithEllipsisOpen,
  textareaWrapper,
} from "./styles.css";
import { ChangeEvent, forwardRef } from "react";
import classNames from "classnames";

type TextareaProps = {
  placeholder?: string;
  name?: string;
  textareaClassName?: string;
  textareaWrapperClassName?: string;
  value?: string;
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  onFocus?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  isEditMode?: boolean;
  optionalText: string;
};
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      name,
      textareaClassName,
      textareaWrapperClassName,
      placeholder,
      value,
      onChange,
      onFocus,
      onBlur,
      isEditMode,
      optionalText,
    }: TextareaProps,
    textareaRef,
  ) => {
    return (
      <div className={classNames(textareaWrapperClassName, textareaWrapper)}>
        <textarea
          ref={textareaRef}
          name={name}
          placeholder={placeholder}
          className={classNames(textarea, textareaClassName, {
            [openTextarea]: isEditMode,
          })}
          data-lenis-prevent
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
        />
        <div
          className={classNames(textareaWithEllipsis, {
            [textareaWithEllipsisOpen]: isEditMode || !value,
          })}
        >
          {value}
        </div>
        {!value && <div className={optionalLabel}>{optionalText}</div>}
      </div>
    );
  },
);
